/* ══════════════════════════════════════════════════════════════════════
   TN CUSTOMER GALLERY · v3 — 2026-09-11 — assets/tn-gallery.js
   ----------------------------------------------------------------------
   Vásárlói beépítés-fotók a Trustoo képes véleményeiből.
     · adat:  <proxy>/get-reviews.php?all_with_media=1  (JSON: data.list[])
              — ugyanaz a trustoo.adspy.hu proxy, amit a vélemény-widget
              használ; origin-allowlistes, ezért localhoston 503-at ad.
     · szűrés: data-product="<handle>" → csak a termék saját fotói; ha < 3,
              data-brand (a cím első szava) szerint; ha az is kevés → mind.

   v3 — FOLYAMATOS, UGRÁSMENTES, LUSTA, ÉLES (user: „ne legyen ugrás…
   folyamatosan menjen… ne lassítsa be… lazy… de ne rossz minőségben"):
     · FIX csempeméret. A v1 a képek betöltésére bízta a csempék szélességét
       (→ a sáv szélessége menet közben változott → ugrás); a v2 ezért az
       összes képet ELŐRE betöltötte és lemérte (→ hideg cache-sel több
       másodperces várakozás). A v3 a CDN-től kér eleve pontos méretű,
       középre vágott képet — Alibaba OSS:
         ?x-oss-process=image/resize,m_fill,w_600,h_400/quality,q_82/format,webp
       (3:2, a csempe 2×-es mérete → retina-éles, ~30 KB / kép). Így a sáv
       szélessége a felépítés pillanatától fix, a két készlet azonos, a -50 %
       varrat pontos — és semmit nem kell megvárni.
     · Lustaság: a szekció csak ~600 px-re a viewporttól indul; a képek
       loading="lazy" (az első 5 soronként eager, hogy ne „pattanjanak be"
       mozgás közben). A sáv csak látható állapotban fut, hoverre megáll.
     · A régi „trustoo_small" (220×102) helyett tehát 600×400 WebP megy —
       ez a minőség-ugrás, ami hiányzott.
     · lightbox: <dialog>, nagy kép (h_1200) / videó-iframe, név, csillag,
       dátum, vélemény-részlet, „Megnézem a terméket", ← → billentyű.
     · cache: sessionStorage 5 perc. Hiba / < 3 kép → a szekció eltűnik.
   Dev: nem élő témán (data-dev) a ?tn_gal=<url> paraméter felülírja a forrást.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-tn-gallery]');
  if (!roots.length) return;

  var CACHE = 'tn_gal_v3:', TTL = 5 * 60 * 1000;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = 38;      /* px / s — nyugodt, olvasható tempó, minden sorban azonos */
  var RATIO = 1.5;     /* csempe szélesség / magasság (3:2) */
  var EAGER = 5;       /* soronként ennyi kép tölt azonnal, a többi lazy */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* A termékcím rövidítése — ugyanaz a szabály, mint a termékoldal H1-jén
     (product-template-airtable): a col-jel („ ″ colos) szavától vágunk. */
  function shortTitle(t) {
    var w = String(t || '').split(' '), out = [];
    for (var i = 0; i < w.length; i++) { if (/["″]|colos/.test(w[i])) break; out.push(w[i]); }
    return (out.join(' ') || t || '').replace(/- /g, '–').replace(/ -/g, '–');
  }
  function stars(n) {
    n = Math.round(+n || 0); var s = '';
    for (var i = 1; i <= 5; i++) s += '<i' + (i <= n ? ' class="is-on"' : '') + '>★</i>';
    return s;
  }
  function fmtDate(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    return d.getFullYear() + '. ' + ('0' + (d.getMonth() + 1)).slice(-2) + '. ' + ('0' + d.getDate()).slice(-2) + '.';
  }
  /* Trustoo (Alibaba OSS) kép: w×h-ra középre vágva (m_fill), WebP.
     h nélkül: csak magasságra méretez (lightbox). Más hostnál marad az URL. */
  function sized(url, w, h) {
    if (!url) return '';
    if (!/img\.trustoo\.io\//.test(url)) return url;
    var base = url.split('?')[0];
    return w ? base + '?x-oss-process=image/resize,m_fill,w_' + w + ',h_' + h + '/quality,q_82/format,webp'
             : base + '?x-oss-process=image/resize,h_' + h + '/quality,q_82/format,webp';
  }

  function load(src) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE + src) || 'null');
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch(src, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var d = (j && j.data && j.data.list) || [];
        try { sessionStorage.setItem(CACHE + src, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      });
  }

  function normalize(list) {
    return list.filter(function (r) { return r && r.media && r.media.length && r.is_published !== 0; })
      .map(function (r) {
        var img = null, vid = null;
        for (var i = 0; i < r.media.length; i++) {
          var m = r.media[i];
          if (m.type === 2 && !vid) vid = m; else if (!img) img = m;
        }
        var base = img ? (img.full || img.url) : (vid.thumbnail_url || vid.thumb || '');
        return {
          id: r.id, rating: +r.rating || 5, author: r.author || 'Vásárló',
          date: r.commented_at || r.created_at || '', content: r.content || '',
          base: base,
          // 2026-09-15: a reviews-api minden médiához ad kis képet (480 px) — a rács-csempe ezt tölti, a nagyítás a nagyot
          thumb: img ? (img.thumbnail_url || img.thumb || '') : (vid.thumbnail_url || vid.thumb || ''),
          full: img ? sized(img.full || img.url, 0, 1200) : base,
          video: vid ? vid.url : '',
          poster: vid ? (vid.thumbnail_url || vid.thumb || '') : '',
          product: r.product || {}
        };
      }).filter(function (i) { return !!i.base; })
      // 2026-09-25: ugyanaz a vevő ugyanazt a fotót több termékéhez is feltöltötte → vevőnként és naponként egy csempe
      .filter((function () { var seen = {}; return function (i) { var k = (i.author || '') + '|' + String(i.date || '').slice(0, 10); if (seen[k]) return false; seen[k] = 1; return true; }; })());
  }

  /* 2026-09-23 (gallery-fill): a terméklapon eddig csak a termék / a márka 3–7 fotója jelent meg → egyetlen
     sor, a lefoglalt második sor helye üresen maradt. Most SORREND, nem szűrés: előbb a termék saját fotói,
     utána a márkáé, végül a többi vásárlói fotó → mindig két teli sor. */
  function pick(items, root) {
    var h = root.getAttribute('data-product');
    if (!h) return items;
    var brand = (root.getAttribute('data-brand') || '').toLowerCase();
    var same = [], br = [], rest = [];
    items.forEach(function (i) {
      if (i.product && i.product.handle === h) same.push(i);
      else if (brand && String(i.product && i.product.title || '').toLowerCase().indexOf(brand) === 0) br.push(i);
      else rest.push(i);
    });
    return same.concat(br, rest);
  }

  /* 2026-09-23 (gallery-preload): minden csempe-kép azonnal, alacsony prioritással tölt (a galéria maga csak a
     viewport közelében épül fel, a lapbetöltést nem lassítja). A lusta (loading=lazy) kép az overflow:hidden
     sávban csak akkor indult, amikor már becsúszott → sötét csempe, majd „bepattanás" (villogás). */
  function tile(it, idx, W, H, eager, dupTile) {
    var t = shortTitle(it.product && it.product.title);
    return '<button type="button" class="tn-gal__tile" style="width:' + W + 'px" data-i="' + idx + '"' + (dupTile ? ' tabindex="-1" aria-hidden="true"' : '') + ' aria-label="' + esc(it.author) + (t ? ' — ' + esc(t) : '') + '">' +
      '<img class="tn-gal__img" draggable="false" src="' + esc(/img\.trustoo\.io\//.test(it.base) ? sized(it.base, W * 2, H * 2) : (it.thumb || it.base)) + '" width="' + (W * 2) + '" height="' + (H * 2) + '" alt="' + esc(t ? t + ' — vásárlói beépítés-fotó' : 'Vásárlói beépítés-fotó') + '" loading="eager" fetchpriority="' + (eager ? 'auto' : 'low') + '" decoding="async">' +
      (it.video ? '<span class="tn-gal__play" aria-hidden="true">▶</span>' : '') +
      '<span class="tn-gal__meta"><span class="tn-gal__stars" aria-hidden="true">' + stars(it.rating) + '</span>' +
      '<span class="tn-gal__who">' + esc(it.author) + '</span>' +
      (t ? '<span class="tn-gal__prod">' + esc(t) + '</span>' : '') + '</span></button>';
  }

  function row(items, offset, rev, W, H, gap) {
    var html = '';
    items.forEach(function (it, i) { html += tile(it, offset + i, W, H, i < EAGER); });
    /* 2026-09-23 (gallery-fill): egy készlet legyen legalább a képernyő + egy csempe széles — különben (kevés
       kép, széles képernyő) jobbról üres hézag csúszott be, majd a sáv visszaugrott. A pótló csempék ugyanazok
       a képek (a böngésző cache-éből jönnek), a billentyűzet és a képernyőolvasó elől rejtve. */
    var setW = items.length * (W + gap), need = (window.innerWidth || 1366) + W + gap, k = 0;
    while (!reduced && items.length && setW < need && k < 200) {
      var it = items[k % items.length];
      html += tile(it, offset + (k % items.length), W, H, false, true);
      setW += W + gap; k++;
    }
    var dur = Math.max(20, Math.round(setW / SPEED));
    /* a másolat-készlet ugyanazokat az URL-eket kéri → a cache-ből jön, nem tölt kétszer */
    var dup = reduced ? '' : '<div class="tn-gal__set" aria-hidden="true">' + html.replace(/<button (?![^>]*tabindex)/g, '<button tabindex="-1" ') + '</div>';
    return '<div class="tn-gal__viewport"><div class="tn-gal__track tn-gal__track--js' + (rev ? ' tn-gal__track--rev' : '') + '" style="--tng-dur:' + dur + 's">' +
      '<div class="tn-gal__set">' + html + '</div>' + dup + '</div></div>';
  }

  /* ── lightbox (egy közös <dialog>) ──
     2026-09-23 (lb-v2): (1) a közvetlen videófájl (mp4/webm/mov) NATÍV <video>-ban megy — iframe-ben az
     app.topnavi.hu frame-ancestors fejléce miatt „visszautasította a csatlakozást"; (2) minden képernyőn
     belefér: mobilon teljes képernyő, asztalon középre igazított doboz, fekvő telefonon kompakt felirat;
     (3) előbb azonnal a kis előnézet látszik, a nagy kép rátöltődik (nincs üres fekete doboz), a szomszédok
     előre töltődnek; (4) ujjal húzva lapozható, számláló. */
  var lb = null, lbItems = [], lbIdx = 0;
  var isFileVideo = function (u) { return /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(String(u || '')); };
  function ensureLb() {
    if (lb) return lb;
    lb = document.createElement('dialog');
    lb.className = 'tn-lb';
    lb.setAttribute('aria-label', 'Vásárlói fotó');
    lb.innerHTML = '<div class="tn-lb__box">' +
      '<button type="button" class="tn-lb__close" data-lb-close aria-label="Bezárás">✕</button>' +
      '<div class="tn-lb__media" data-lb-media></div>' +
      '<button type="button" class="tn-lb__btn tn-lb__btn--prev" data-lb-prev aria-label="Előző">‹</button>' +
      '<button type="button" class="tn-lb__btn tn-lb__btn--next" data-lb-next aria-label="Következő">›</button>' +
      '<span class="tn-lb__count" data-lb-count aria-live="polite"></span>' +
      '<div class="tn-lb__cap"><div class="tn-lb__txt" data-lb-txt></div><a class="tn-lb__cta" data-lb-cta href="#">Megnézem a terméket →</a></div>' +
      '</div>';
    document.body.appendChild(lb);
    lb.querySelector('[data-lb-close]').addEventListener('click', function () { lb.close(); });
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { show(lbIdx - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { show(lbIdx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    /* a close esemény aszinkron jön: ha közben már újranyitották (másik csempe), ne ürítsük ki az új tartalmat */
    lb.addEventListener('close', function () {
      if (lb.open) return;
      document.body.classList.remove('tn-lb-open');
      var md = lb.querySelector('[data-lb-media]'), v = md.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      md.innerHTML = '';
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(lbIdx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(lbIdx + 1); }
    });
    /* ujjal lapozás: vízszintes húzás a médián (a függőleges görgetés marad) */
    var media = lb.querySelector('[data-lb-media]'), sx = 0, sy = 0, st = 0, tracking = false;
    media.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; tracking = true; sx = e.clientX; sy = e.clientY; st = Date.now(); });
    media.addEventListener('pointerup', function (e) {
      if (!tracking) return; tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - st < 800 && lbItems.length > 1) show(lbIdx + (dx < 0 ? 1 : -1));
    });
    media.addEventListener('pointercancel', function () { tracking = false; });
    return lb;
  }
  function preload(i) {
    var n = lbItems.length; if (n < 2) return;
    var it = lbItems[(i + n) % n];
    if (it && !it.video && it.full) { var im = new Image(); im.decoding = 'async'; im.src = it.full; }
  }
  function show(i) {
    var n = lbItems.length; if (!n) return;
    lbIdx = (i + n) % n;
    var it = lbItems[lbIdx], t = shortTitle(it.product && it.product.title);
    var media = lb.querySelector('[data-lb-media]');
    var alt = t ? t + ' — vásárlói beépítés-fotó' : 'Vásárlói beépítés-fotó';
    if (it.video && isFileVideo(it.video)) {
      media.innerHTML = '<video class="tn-lb__video" src="' + esc(it.video) + '"' + ((it.poster || it.thumb) ? ' poster="' + esc(it.poster || it.thumb) + '"' : '') +
        ' controls playsinline preload="metadata" autoplay muted aria-label="Vásárlói videó"></video>';
    } else if (it.video) {
      media.innerHTML = '<iframe src="' + esc(it.video) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Vásárlói videó"></iframe>';
    } else {
      /* azonnal a (már cache-ben lévő) kis kép, fölé tölt a nagy — betöltéskor finoman vált */
      var low = it.thumb && it.thumb !== it.full ? '<img class="tn-lb__low" src="' + esc(it.thumb) + '" alt="" aria-hidden="true">' : '';
      media.innerHTML = '<div class="tn-lb__frame">' + low + '<img class="tn-lb__img" src="' + esc(it.full) + '" alt="' + esc(alt) + '" decoding="async"></div>';
      var big = media.querySelector('.tn-lb__img');
      var done = function () { big.classList.add('is-in'); if (big.parentNode) big.parentNode.classList.add('is-loaded'); };
      if (big.complete && big.naturalWidth) done(); else { big.addEventListener('load', done); big.addEventListener('error', done); }
    }
    lb.querySelector('[data-lb-txt]').innerHTML =
      '<span class="tn-lb__who"><span class="tn-gal__stars" aria-label="' + it.rating + ' csillag">' + stars(it.rating) + '</span>' + esc(it.author) +
      (it.date ? '<span class="tn-lb__date">' + esc(fmtDate(it.date)) + '</span>' : '') + '</span>' +
      (t ? '<span class="tn-lb__prodname">' + esc(t) + '</span>' : '') +
      (it.content ? '<span class="tn-lb__quote">„' + esc(it.content) + '”</span>' : '');
    var cta = lb.querySelector('[data-lb-cta]');
    if (it.product && it.product.handle) { cta.hidden = false; cta.href = '/products/' + it.product.handle; }
    else { cta.hidden = true; }
    lb.querySelectorAll('[data-lb-prev],[data-lb-next]').forEach(function (b) { b.hidden = n < 2; });
    var cnt = lb.querySelector('[data-lb-count]'); cnt.textContent = n > 1 ? (lbIdx + 1) + ' / ' + n : ''; cnt.hidden = n < 2;
    preload(lbIdx + 1); preload(lbIdx - 1);
  }
  function open(items, i) {
    ensureLb(); lbItems = items;
    show(i);
    document.body.classList.add('tn-lb-open');
    if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
  }

  /* ── gallery-drag (2026-09-18): JS-vezérelt sodródás + ujjal/egérrel húzás lendülettel ──
     A sáv két azonos készletből áll; a transzform a készlet szélességén belül forog (wrap), így végtelen.
     Nyugalomban SPEED px/s-sel sodródik (a fordított sor ellenkező irányba); egér-hoverre megáll.
     Húzás: pointer events (touch-action: pan-y → a függőleges görgetés natív marad). Elengedéskor a mért
     sebesség exponenciálisan simul vissza a sodródáshoz (≈0,45 s időállandó) — ez a „lendület". */
  function initDrift(track) {
    var vp = track.parentNode, set = track.querySelector('.tn-gal__set');
    if (!vp || !set) return;
    var rev = track.classList.contains('tn-gal__track--rev');
    var W = 0, x = 0, v = 0, auto = (rev ? 1 : -1) * SPEED, live = false, hover = false, dragging = false;
    var raf = 0, lastT = 0, px = 0, moved = 0, samples = [], tapHandled = false;
    function measure() { W = set.getBoundingClientRect().width || W; }
    measure();
    x = rev ? -W + 1 : 0;
    v = auto;
    function wrap() { if (W <= 0) return; if (x <= -W) x += W; else if (x > 0) x -= W; }
    function paint() { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; }
    function frame(t) {
      raf = 0;
      if (!live) return;
      var dt = lastT ? Math.min(0.05, (t - lastT) / 1000) : 0; lastT = t;
      if (!dragging) {
        var target = hover ? 0 : auto;
        v += (target - v) * Math.min(1, dt * 2.2);
        if (dt) { x += v * dt; wrap(); paint(); }
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (!raf) { lastT = 0; raf = requestAnimationFrame(frame); } }
    track.__drift = function (on) { live = !!on; if (live) start(); };
    vp.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    vp.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = 0; px = e.clientX; samples = [];
      try { vp.setPointerCapture(e.pointerId); } catch (err) {}
      vp.classList.add('is-dragging');
      start();
    });
    vp.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - px; px = e.clientX; moved += Math.abs(dx);
      x += dx; wrap(); paint();
      var now = performance.now(); samples.push([now, dx]);
      while (samples.length && now - samples[0][0] > 120) samples.shift();
    });
    function end(e) {
      if (!dragging) return;
      dragging = false; vp.classList.remove('is-dragging');
      /* gallery-tap: koppintás/kattintás (nem húzás) → a pointerup alatti csempe nyitása; a natív click-et (ami a
         capture miatt a viewportra érkezne) elnyeljük */
      if (moved <= 8 && e && e.type === 'pointerup') {
        var el = document.elementFromPoint(e.clientX, e.clientY);
        var tile = el && el.closest ? el.closest('.tn-gal__tile') : null;
        if (tile) { tile.click(); tapHandled = true; }
      }
      var now = performance.now(), dist = 0, t0 = now;
      samples.forEach(function (s) { dist += s[1]; if (s[0] < t0) t0 = s[0]; });
      var fl = dist / Math.max(16, now - t0) * 1000;
      v = Math.max(-2800, Math.min(2800, fl));
      if (Math.abs(v) < 40) v = hover ? 0 : auto;
      lastT = 0; start();
    }
    vp.addEventListener('pointerup', end);
    vp.addEventListener('pointercancel', end);
    vp.addEventListener('lostpointercapture', end);
    /* húzás után a kattintás ne nyisson lightboxot */
    vp.addEventListener('click', function (e) { if (moved > 8 || tapHandled) { e.stopPropagation(); e.preventDefault(); } tapHandled = false; moved = 0; }, true);
    window.addEventListener('resize', function () { measure(); wrap(); paint(); });
    paint();
  }

  /* ── egy galéria felépítése ── */
  function build(root, items) {
    var rows = root.querySelector('[data-tn-gal-rows]');
    /* a csempe magassága a CSS-változóból; ha a (nem blokkoló) CSS még nem ért
       ide, a viewport szélessége dönt — ugyanaz a két érték, mint a CSS-ben */
    var H = parseInt(getComputedStyle(root).getPropertyValue('--tng-tile-h'), 10) || (window.innerWidth <= 768 ? 150 : 200);
    var gap = parseInt(getComputedStyle(root).getPropertyValue('--tng-gap'), 10) || (window.innerWidth <= 768 ? 8 : 12);
    var W = Math.round(H * RATIO);
    var two = items.length >= 8 && !reduced;
    var html;
    if (two) {
      var a = [], b = [];
      items.forEach(function (it, i) { (i % 2 ? b : a).push(it); });
      html = row(a, 0, false, W, H, gap) + row(b, a.length, true, W, H, gap);
      items = a.concat(b); /* a lightbox indexe a sorok összefűzött listájára mutat */
    } else {
      html = row(items, 0, false, W, H, gap);
    }
    /* 2026-09-23 (gallery-fade): a kép betöltéskor finoman úszik be (nem „pattan"); a load esemény nem buborékol,
       ezért capture-rel figyeljük, és a már cache-ből kész képeket azonnal jelöljük. */
    rows.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') e.target.classList.add('is-in'); }, true);
    rows.addEventListener('error', function (e) { if (e.target.tagName === 'IMG') e.target.classList.add('is-in'); }, true);
    rows.innerHTML = html;
    rows.querySelectorAll('.tn-gal__img').forEach(function (im) { if (im.complete) im.classList.add('is-in'); });
    root.setAttribute('data-ready', '1');
    /* ha csak egy sor lett (8-nál kevesebb kép), a két sornyi lefoglalt hely ne maradjon üres sötét sáv */
    if (!two) { rows.style.minHeight = '0'; root.style.minHeight = '0'; }


    rows.addEventListener('click', function (e) {
      var t = e.target.closest('.tn-gal__tile'); if (!t) return;
      open(items, +t.getAttribute('data-i') || 0);
    });

    /* csak a viewportban fusson — kilépéskor megáll, visszatéréskor onnan folytatja */
    var tracks = rows.querySelectorAll('.tn-gal__track');
    if (!reduced) tracks.forEach(function (tr) { initDrift(tr); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { tracks.forEach(function (tr) { tr.classList.toggle('is-live', en.isIntersecting); if (tr.__drift) tr.__drift(en.isIntersecting); }); });
      }, { rootMargin: '80px 0px' });
      io.observe(root);
    } else {
      tracks.forEach(function (tr) { tr.classList.add('is-live'); if (tr.__drift) tr.__drift(true); });
    }
  }

  roots.forEach(function (root) {
    var src = root.getAttribute('data-src') || '';
    if (root.hasAttribute('data-dev')) {
      /* Dev téma, localhoston: a Trustoo-proxy origin-allowlistes, innen 503-at
         ad → a szekció eltűnne, és a fejlesztő azt hinné, elromlott. Ezért
         `shopify theme dev` alatt (127.0.0.1 / localhost) a mentett JSON-
         pillanatkép jön a helyi teszt-szerverről (:4321, scratchpad
         preview/galsrv.js); a ?tn_gal=<url> paraméter ezt is felülírja.
         Élő témán (theme.role == main) nincs data-dev, ez az ág nem fut. */
      if (/^(localhost|127\.0\.0\.1)$/.test(location.hostname)) src = 'http://localhost:4321/tr.json';
      try { var q = new URLSearchParams(location.search).get('tn_gal'); if (q) src = q; } catch (e) {}
    }
    if (!src) { root.hidden = true; return; }
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 40;
    /* mobilon kevesebb kép (sávszélesség): két sorban 16 bőven kitölti a keskeny képernyőt */
    if ((window.innerWidth || 1366) <= 768) limit = Math.min(limit, 16);

    function go() {
      load(src).then(function (list) {
        var items = pick(normalize(list), root).slice(0, limit);
        if (items.length < 3) { root.hidden = true; return; }
        build(root, items);
      }).catch(function () { root.hidden = true; });
    }
    /* lusta indítás: csak amikor a szekció a viewport közelébe ér */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es, obs) {
        if (es.some(function (e) { return e.isIntersecting; })) { obs.disconnect(); root.classList.add('is-near'); go(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else { root.classList.add('is-near'); go(); }
  });
})();
